(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gu-bestsellers"] && !Shopify.designMode) return;
  try {
    
(function() {
  var isMobile  = window.innerWidth < 750;
  var supportsIO = 'IntersectionObserver' in window;

  /* Inicializar cada instancia del módulo por separado */
  document.querySelectorAll('.gubest').forEach(function(section) {
    var header    = section.querySelector('[data-gubest-reveal]');
    var realCards = Array.prototype.slice.call(section.querySelectorAll('.gubest__card'));
    if (!realCards.length) return;

    /* ── Fallback sin IntersectionObserver ───────────────────── */
    if (!supportsIO) {
      if (header) header.classList.add('gubest--visible');
      realCards.forEach(function(c) { c.classList.add('gubest--card-visible'); });
      return;
    }

    /* ── Header scroll reveal ────────────────────────────────── */
    if (header) {
      new IntersectionObserver(function(entries, obs) {
        if (entries[0].isIntersecting) {
          entries[0].target.classList.add('gubest--visible');
          obs.disconnect();
        }
      }, { threshold: 0.2 }).observe(header);
    }

    /* ── Card entrance — escalonado ─────────────────────────── */
    var cardObs = new IntersectionObserver(function(entries, obs) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('gubest--card-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -20px 0px' });

    realCards.forEach(function(card, i) {
      card.style.transitionDelay = (i * 0.1) + 's';
      cardObs.observe(card);
    });

    /* ── Carrusel infinite loop — mobile only ───────────────── */
    if (!isMobile || realCards.length < 2) return;

    var grid = section.querySelector('.gubest__grid');
    if (!grid) return;

    /* Medir antes de clonar */
    var r0   = realCards[0].getBoundingClientRect();
    var r1   = realCards[1].getBoundingClientRect();
    var cW   = r0.width;
    var gW   = Math.round(r1.left - r0.right);
    var jmpW = realCards.length * (cW + gW);

    /* Pre-clones — se insertan antes del primer card real */
    var fPre = document.createDocumentFragment();
    realCards.forEach(function(c) {
      var cl = c.cloneNode(true);
      cl.classList.add('gubest__card--clone');
      cl.setAttribute('aria-hidden', 'true');
      cl.style.transitionDelay = '0s';
      fPre.appendChild(cl);
    });
    grid.insertBefore(fPre, realCards[0]);

    /* Post-clones — se insertan después del último card real */
    var fPost = document.createDocumentFragment();
    realCards.forEach(function(c) {
      var cl = c.cloneNode(true);
      cl.classList.add('gubest__card--clone');
      cl.setAttribute('aria-hidden', 'true');
      cl.style.transitionDelay = '0s';
      fPost.appendChild(cl);
    });
    grid.appendChild(fPost);

    /* Posición inicial = primer card real */
    grid.scrollLeft = jmpW;

    /* Salto silencioso al detectar zona de clones */
    var jumping = false;
    function jump(delta) {
      jumping = true;
      grid.style.scrollSnapType = 'none';
      grid.scrollLeft += delta;
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          grid.style.scrollSnapType = 'x mandatory';
          jumping = false;
        });
      });
    }

    function check() {
      if (jumping) return;
      var sl = grid.scrollLeft;
      if (sl < jmpW - 1)          jump(jmpW);
      else if (sl >= jmpW * 2 - 1) jump(-jmpW);
    }

    if ('onscrollend' in window) {
      grid.addEventListener('scrollend', check, { passive: true });
    } else {
      var t = null;
      grid.addEventListener('scroll', function() {
        clearTimeout(t);
        t = setTimeout(check, 200);
      }, { passive: true });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gu-favoritos"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function money(cents) {
      if (typeof cents !== 'number') cents = parseFloat(cents) || 0;
      var n = (cents / 100).toFixed(2).replace('.', ',');
      var parts = n.split(',');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '$' + parts.join(',');
    }

    function escapeHtml(s) {
      return String(s || '').replace(/[&<>"']/g, function(c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function fetchProduct(handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function(r) { if (!r.ok) throw new Error('not found'); return r.json(); })
        .catch(function() { return null; });
    }

    function renderCard(p) {
      if (!p) return '';
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var imgSrc = img ? (typeof img === 'string' ? img : (img.src || '')) : '';
      if (imgSrc && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
      var imgUrl = imgSrc ? imgSrc.replace(/(\.(?:png|jpg|jpeg|webp))/i, '_400x400$1') : '';
      var vendor = p.vendor ? escapeHtml(p.vendor) : '';
      var title = escapeHtml(p.title);
      var url = p.url || ('/products/' + p.handle);
      var available = p.available;
      var firstVariantId = p.variants && p.variants[0] ? p.variants[0].id : null;
      var price = money(p.price);
      var compareAt = p.compare_at_price && p.compare_at_price > p.price ? '<span class="gu-fav-card__price-compare">' + money(p.compare_at_price) + '</span>' : '';

      var ctaHtml = available && firstVariantId
        ? '<button type="button" class="gu-fav-card__cta" data-gu-fav-add data-variant-id="' + firstVariantId + '" data-handle="' + escapeHtml(p.handle) + '">Sumar al carrito</button>'
        : '<div class="gu-fav-card__sold-out">Sin stock</div>';

      return ''
        + '<article class="gu-fav-card" data-gu-fav-card data-handle="' + escapeHtml(p.handle) + '">'
        +   '<a class="gu-fav-card__img-link" href="' + url + '" aria-label="' + title + '">'
        +     (imgUrl ? '<img class="gu-fav-card__img" src="' + imgUrl + '" alt="' + title + '" loading="lazy" width="400" height="400">' : '')
        +   '</a>'
        +   '<button type="button" class="gu-fav-card__remove" data-gu-fav-remove data-handle="' + escapeHtml(p.handle) + '" aria-label="Quitar de favoritos" title="Quitar de favoritos">'
        +     '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
        +   '</button>'
        +   '<div class="gu-fav-card__body">'
        +     (vendor ? '<span class="gu-fav-card__vendor">' + vendor + '</span>' : '')
        +     '<h3 class="gu-fav-card__title"><a href="' + url + '">' + title + '</a></h3>'
        +     '<div class="gu-fav-card__price">' + price + compareAt + '</div>'
        +     ctaHtml
        +   '</div>'
        + '</article>';
    }

    function updateCountText(n) {
      var el = document.querySelector('[data-gu-fav-count-text]');
      if (!el) return;
      el.textContent = n + ' producto' + (n === 1 ? '' : 's') + ' guardado' + (n === 1 ? '' : 's');
    }

    function render() {
      var grid = document.querySelector('[data-gu-fav-grid]');
      var loading = document.querySelector('[data-gu-fav-loading]');
      var empty = document.querySelector('[data-gu-fav-empty]');
      if (!grid || !loading || !empty) return;

      if (!window.GuWishlist) {
        setTimeout(render, 80);
        return;
      }

      var handles = window.GuWishlist.list();
      updateCountText(handles.length);

      if (handles.length === 0) {
        loading.hidden = true;
        grid.hidden = true;
        grid.innerHTML = '';
        empty.hidden = false;
        return;
      }

      loading.hidden = false;
      grid.hidden = true;
      empty.hidden = true;

      Promise.all(handles.map(fetchProduct)).then(function(products) {
        var validHandles = [];
        var html = '';
        products.forEach(function(p, i) {
          if (p) {
            validHandles.push(handles[i]);
            html += renderCard(p);
          }
        });

        if (validHandles.length !== handles.length) {
          try {
            localStorage.setItem(window.GuWishlist.KEY, JSON.stringify(validHandles));
          } catch (e) {}
        }

        loading.hidden = true;
        if (validHandles.length === 0) {
          grid.hidden = true;
          empty.hidden = false;
          updateCountText(0);
        } else {
          grid.innerHTML = html;
          grid.hidden = false;
          empty.hidden = true;
          updateCountText(validHandles.length);
        }
      });
    }

    function onAdd(e) {
      var btn = e.target.closest && e.target.closest('[data-gu-fav-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      btn.classList.add('is-loading');
      var original = btn.textContent;
      btn.textContent = 'Agregando…';

      var body = 'id=' + encodeURIComponent(String(id)) + '&quantity=1';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: body
      })
        .then(function(r) {
          if (!r.ok) return r.json().then(function(j){ throw new Error(j.description || 'add failed'); });
          return r.json();
        })
        .then(function() {
          btn.textContent = '✓ Sumado';
          if (typeof window.refreshCartBubble === 'function') window.refreshCartBubble();
          if (typeof window.refreshDrawerAndOpen === 'function') window.refreshDrawerAndOpen();
          setTimeout(function() {
            btn.textContent = original;
            btn.classList.remove('is-loading');
          }, 1400);
        })
        .catch(function(err) {
          btn.textContent = (err && err.message) ? 'Error: ' + err.message.slice(0,30) : 'Error, reintentá';
          setTimeout(function() {
            btn.textContent = original;
            btn.classList.remove('is-loading');
          }, 1800);
        });
    }

    function onRemove(e) {
      var btn = e.target.closest && e.target.closest('[data-gu-fav-remove]');
      if (!btn) return;
      e.preventDefault();
      var h = btn.getAttribute('data-handle');
      if (!h || !window.GuWishlist) return;
      var card = btn.closest('[data-gu-fav-card]');
      if (card) {
        card.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
        card.style.opacity = '0';
        card.style.transform = 'scale(0.95)';
        setTimeout(function() { window.GuWishlist.remove(h); render(); }, 220);
      } else {
        window.GuWishlist.remove(h);
        render();
      }
    }

    function init() {
      render();
      document.addEventListener('click', onAdd);
      document.addEventListener('click', onRemove);
      document.addEventListener('gu:wishlist:change', function(e) {
        if (e && e.detail && (e.detail.action === 'add' || e.detail.action === 'storage')) render();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gu-featured-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  var els = document.querySelectorAll('[data-gufp-reveal]');
  if (!els.length) return;

  if (!('IntersectionObserver' in window)) {
    els.forEach(function(el) { el.classList.add('gufp--visible'); });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('gufp--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  els.forEach(function(el) { observer.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gu-product-ficha"]) return;
  try {
    
(function () {
  'use strict';
  document.querySelectorAll('.gu-ficha__accordion').forEach(function (det) {
    var header = det.querySelector('.gu-ficha__head');
    var panel  = det.querySelector('.gu-ficha__panel');
    if (!header || !panel) return;
    var animating = false;

    header.addEventListener('click', function (e) {
      e.preventDefault();
      if (animating) return;

      if (det.open) {
        var fromH = panel.scrollHeight;
        panel.style.maxHeight = fromH + 'px';
        animating = true;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            panel.style.maxHeight = '0';
            panel.addEventListener('transitionend', function close() {
              panel.removeEventListener('transitionend', close);
              det.removeAttribute('open');
              panel.setAttribute('aria-hidden', 'true');
              animating = false;
            });
          });
        });
      } else {
        det.setAttribute('open', '');
        panel.setAttribute('aria-hidden', 'false');
        var toH = panel.scrollHeight + 'px';
        panel.style.maxHeight = '0';
        animating = true;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            panel.style.maxHeight = toH;
            panel.addEventListener('transitionend', function open() {
              panel.removeEventListener('transitionend', open);
              panel.style.maxHeight = 'none';
              animating = false;
            });
          });
        });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gu-productos-en-accion"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSection(el) {
    var scroll  = el.querySelector('.gu-accion__scroll');
    var track   = el.querySelector('.gu-accion__track');
    var cards   = Array.prototype.slice.call(el.querySelectorAll('.gu-accion__card'));
    var arrows  = Array.prototype.slice.call(el.querySelectorAll('.gu-accion__arrow'));
    var videos  = Array.prototype.slice.call(el.querySelectorAll('.gu-accion__video'));
    var autoplay = el.dataset.autoplay === 'true';

    if (!scroll || !cards.length) return;

    /* ── Medición del paso de scroll (distancia entre inicios de tarjeta) ── */
    function getStep() {
      var c0 = cards[0], c1 = cards[1];
      if (!c0) return 260;
      if (!c1) return c0.offsetWidth + 16;
      return c1.getBoundingClientRect().left - c0.getBoundingClientRect().left;
    }

    /* ── Arrows ── */
    if (arrows.length) {
      arrows.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.dataset.dir, 10);
          scroll.scrollBy({ left: dir * getStep(), behavior: 'smooth' });
        });
      });

      function syncArrows() {
        var max = scroll.scrollWidth - scroll.clientWidth;
        arrows[0].disabled = scroll.scrollLeft <= 1;
        arrows[1].disabled = scroll.scrollLeft >= max - 1;
      }

      scroll.addEventListener('scroll', syncArrows, { passive: true });
      syncArrows();
    }

    /* ── Carrusel sin fin: clona y loopea ── */
    (function () {
      var origLen = cards.length;
      if (origLen < 2) return;

      // Clonar todas las cards originales y agregarlas al final del track
      var frag = document.createDocumentFragment();
      cards.forEach(function (c) {
        var clone = c.cloneNode(true);
        clone.classList.add('gu-accion__card--clone');
        clone.setAttribute('aria-hidden', 'true');
        frag.appendChild(clone);
      });
      track.appendChild(frag);

      // Actualizar cards y videos para incluir los clones
      cards  = Array.prototype.slice.call(el.querySelectorAll('.gu-accion__card'));
      videos = Array.prototype.slice.call(el.querySelectorAll('.gu-accion__video'));

      // Ancho total del set original (cards + gaps)
      function getSetWidth() {
        var gap  = parseFloat(window.getComputedStyle(track).columnGap) || 14;
        var first = track.children[0];
        var last  = track.children[origLen - 1];
        if (!first || !last) return 0;
        return last.offsetLeft + last.offsetWidth + gap - first.offsetLeft;
      }

      var jumping = false;
      function tryLoop() {
        if (jumping) return;
        var setW = getSetWidth();
        if (!setW || scroll.scrollLeft < setW) return;
        jumping = true;
        scroll.style.scrollSnapType = 'none';
        scroll.scrollLeft -= setW;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            scroll.style.scrollSnapType = '';
            jumping = false;
          });
        });
      }

      // Scrollend (moderno) + fallback timeout
      var loopTimer;
      scroll.addEventListener('scroll', function () {
        clearTimeout(loopTimer);
        loopTimer = setTimeout(tryLoop, 150);
      }, { passive: true });
      scroll.addEventListener('scrollend', tryLoop, { passive: true });
    }());

    /* ── Autoplay via IntersectionObserver ── */
    var prefersReduced = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false;

    if (autoplay && !prefersReduced && videos.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.4) {
            v.play().catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: [0, 0.4] });

      videos.forEach(function (v) { io.observe(v); });
    }

    /* ── Auto-scroll horizontal del carrusel ── */
    if (!prefersReduced && cards.length > 1) {
      var autoTimer = null;
      var resumeTimer = null;
      var AUTO_DELAY = 4500;

      function autoStart() {
        if (autoTimer) return;
        autoTimer = setInterval(function () {
          scroll.scrollBy({ left: getStep(), behavior: 'smooth' });
        }, AUTO_DELAY);
      }
      function autoStop() {
        if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
      }
      function autoResumeLater() {
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(autoStart, 3500);
      }

      el.addEventListener('mouseenter', autoStop);
      el.addEventListener('mouseleave', autoStart);
      scroll.addEventListener('touchstart', function () {
        autoStop();
        clearTimeout(resumeTimer);
      }, { passive: true });
      scroll.addEventListener('touchend', autoResumeLater, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) autoStop(); else autoStart();
      });

      autoStart();
    }

    /* ── Mobile center-scale: detecta la card centrada ── */
    (function () {
      function isMobile() { return window.innerWidth < 750; }

      function getActiveCard() {
        var mid = scroll.scrollLeft + scroll.clientWidth / 2;
        var best = null, bestDist = Infinity;
        cards.forEach(function (c) {
          var dist = Math.abs((c.offsetLeft + c.offsetWidth / 2) - mid);
          if (dist < bestDist) { bestDist = dist; best = c; }
        });
        return best;
      }

      function updateActive() {
        if (!isMobile()) {
          cards.forEach(function (c) { c.classList.remove('is-center'); });
          return;
        }
        var active = getActiveCard();
        cards.forEach(function (c) {
          c.classList.toggle('is-center', c === active);
        });
      }

      var raf = false;
      scroll.addEventListener('scroll', function () {
        if (!raf) {
          raf = true;
          requestAnimationFrame(function () { updateActive(); raf = false; });
        }
      }, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateActive, 150);
      }, { passive: true });

      updateActive();
    }());

    /* ── Sound toggle ── */
    el.querySelectorAll('.gu-accion__sound').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        /* Si el video-wrap es un <a>, prevenir navegación cuando se clickea el botón sonido */
        e.preventDefault();
        e.stopPropagation();

        var wrap  = btn.closest('.gu-accion__video-wrap');
        var video = wrap && wrap.querySelector('.gu-accion__video');
        if (!video) return;

        video.muted = !video.muted;

        /* Si se activa sonido y el video está pausado, intentar reproducir */
        if (!video.muted && video.paused) {
          video.play().catch(function () { video.muted = true; });
        }

        btn.dataset.muted = String(video.muted);
        btn.setAttribute('aria-label', video.muted ? 'Activar sonido' : 'Silenciar');
      });
    });
  }

  /* ── Inicializar todas las secciones en la página ── */
  function initAll() {
    document.querySelectorAll('[id^="gu-accion-"]').forEach(function (el) {
      if (!el.dataset.guAccionReady) {
        el.dataset.guAccionReady = '1';
        initSection(el);
      }
    });
  }

  /* ── Boot (guard para evitar doble registro) ── */
  if (!window.__guAccionBooted) {
    window.__guAccionBooted = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    /* Shopify theme editor: re-init al cargar/recargar sección */
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[id^="gu-accion-"]');
      if (el) { delete el.dataset.guAccionReady; initSection(el); }
    });

    document.addEventListener('shopify:section:reorder', initAll);

  } else {
    /* La sección se cargó dinámicamente — init las nuevas */
    initAll();
  }

  /* ───────────────────────── ADD TO CART (botón +) ─────────────────────── */
  function refreshCartIconBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (data) {
      if (!data['cart-icon-bubble']) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
      var fresh = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
      if (fresh) bubble.innerHTML = fresh.innerHTML;
    }).catch(function () { });
  }

  function notifyCartDrawer() {
    var drawer = document.querySelector('cart-drawer, cart-notification');
    if (!drawer) return;
    fetch('/?sections=cart-drawer,cart-notification').then(function (r) { return r.json(); }).then(function (data) {
      ['cart-drawer', 'cart-notification'].forEach(function (key) {
        if (!data[key]) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(data[key], 'text/html');
        var fresh = doc.querySelector(key);
        var current = document.querySelector(key);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      });
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') d.open();
      var n = document.querySelector('cart-notification');
      if (n && typeof n.open === 'function') n.open();
    }).catch(function () { });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.gu-accion__btn[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.status === 'loading') return;

    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) { window.location.href = btn.dataset.productUrl || '/'; return; }

    btn.dataset.status = 'loading';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    })
    .then(function () {
      btn.dataset.status = 'success';
      refreshCartIconBubble();
      notifyCartDrawer();
      document.documentElement.dispatchEvent(new CustomEvent('cart:added', { bubbles: true }));
      setTimeout(function () {
        btn.dataset.status = '';
        btn.disabled = false;
      }, 1600);
    })
    .catch(function (err) {
      btn.dataset.status = '';
      btn.disabled = false;
      if (err && err.description) console.warn('Add to cart:', err.description);
      window.location.href = btn.dataset.productUrl || '/';
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gu-trust-badge"] && !Shopify.designMode) return;
  try {
    
(function() {
  var els = document.querySelectorAll('[data-gutrust-reveal]');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function(el) { el.classList.add('gutrust--visible'); });
    return;
  }
  var obs = new IntersectionObserver(function(entries, o) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('gutrust--visible');
        o.unobserve(e.target);
      }
    });
  }, { threshold: 0.2 });
  els.forEach(function(el) { obs.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const wrap = document.querySelector('[data-gu-header]');
    if (!wrap) return;
    const burguer = wrap.querySelector('[data-gu-burguer]');
    const mobileMenu = wrap.querySelector('[data-gu-mobile-menu]');
    const mobileClose = wrap.querySelector('[data-gu-mobile-close]');
    const overlay = wrap.querySelector('[data-gu-overlay]');
    const searchClose = wrap.querySelector('[data-gu-search-close]');
    const searchBox = wrap.querySelector('[data-gu-search]');
    const searchInput = searchBox ? searchBox.querySelector('input[type="search"]') : null;

    function abrirMenu() {
      if (!mobileMenu) return;
      mobileMenu.classList.add('gu-header-mobile-abierto');
      mobileMenu.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('gu-header-overlay-visible');
      document.body.style.overflow = 'hidden';
      if (burguer) burguer.setAttribute('aria-expanded', 'true');
    }
    function cerrarMenu() {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('gu-header-mobile-abierto');
      mobileMenu.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('gu-header-overlay-visible');
      document.body.style.overflow = '';
      if (burguer) burguer.setAttribute('aria-expanded', 'false');
    }
    if (burguer) burguer.addEventListener('click', abrirMenu);
    if (mobileClose) mobileClose.addEventListener('click', cerrarMenu);
    if (overlay) overlay.addEventListener('click', cerrarMenu);

    wrap.querySelectorAll('[data-gu-mobile-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });

    if (searchBox) {
      wrap.querySelectorAll('[data-gu-search-toggle]').forEach(function(toggle) {
        toggle.addEventListener('click', function(e) {
          e.stopPropagation();
          searchBox.classList.toggle('gu-header-search-abierto');
          if (searchBox.classList.contains('gu-header-search-abierto')) {
            if (searchInput) setTimeout(function() { searchInput.focus(); }, 300);
          } else {
            document.body.style.overflow = '';
          }
        });
      });
    }
    wrap.querySelectorAll('[data-gu-search-close]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        searchBox.classList.remove('gu-header-search-abierto');
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchBox && searchBox.classList.contains('gu-header-search-abierto')) {
        searchBox.classList.remove('gu-header-search-abierto');
        document.body.style.overflow = '';
      }
    });
    document.addEventListener('click', function(e) {
      if (searchBox && searchBox.classList.contains('gu-header-search-abierto') && !searchBox.contains(e.target)) {
        searchBox.classList.remove('gu-header-search-abierto');
        document.body.style.overflow = '';
      }
    });
    if (wrap.classList.contains('gu-header-wrap-sticky')) {
      window.addEventListener('scroll', function() {
        if (window.scrollY > 50) wrap.classList.add('gu-header-scrolled');
        else wrap.classList.remove('gu-header-scrolled');
      }, { passive: true });
    }
  })();

  /* GU CART BADGE SYNC — escucha cambios en el cart-icon-bubble oculto (que Dawn actualiza) y sincroniza el badge visible */
  (function () {
    'use strict';
    function getBubble() { return document.getElementById('cart-icon-bubble'); }
    function getVisible() { return document.querySelector('[data-gu-cart-count]'); }
    function syncCount() {
      var bubble = getBubble();
      var visible = getVisible();
      if (!bubble || !visible) return;
      var inner = bubble.querySelector('.cart-count-bubble span[aria-hidden="true"]') || bubble.querySelector('.cart-count-bubble span');
      var count = inner ? (parseInt(inner.textContent, 10) || 0) : 0;
      visible.textContent = count;
      visible.classList.toggle('gu-header-cart-count-vacio', count === 0);
    }
    function init() {
      var bubble = getBubble();
      if (!bubble) return;
      var observer = new MutationObserver(syncCount);
      observer.observe(bubble, { childList: true, subtree: true, characterData: true });
      // También escuchar el pub/sub de Dawn por si MutationObserver no se gatilla
      if (window.PUB_SUB_EVENTS && window.subscribe) {
        try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, syncCount); } catch (e) {}
      }
      // Escuchar evento custom del hero
      document.addEventListener('gu:cart:added', function () { setTimeout(syncCount, 300); });
      // Initial sync (por si la página cargó después que Dawn JS)
      syncCount();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();
})();
